import { RadioGroup as MuiRadioGroup, RadioGroupProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { RadioGroupProps };

export const RadioGroup: React.ComponentType<RadioGroupProps> = styled(
  MuiRadioGroup,
)<RadioGroupProps>(() => ({}));
